<template>
  <div
    v-if="$store.state.newsletter_modal_opened"
    class="modal infolettre-modal__wrapper"
    @click.self="$store.dispatch('closeNewsletterModal')"
  >
    <div class="infolettre-modal" @click.stop>
      <div class="infolettre-modal__header">
        <h2>S’inscrire à l’infolettre</h2>
        <div @click.stop="$store.dispatch('closeNewsletterModal')">
          <Icon id="close" class="infolettre-modal__close" />
        </div>
      </div>
      <p>
        Recevez des nouvelles inspirantes sur les projets d’aménagement durable, des outils pour
        repenser la ville, et des idées concrètes pour mieux cohabiter avec l’eau.
      </p>
      <iframe
        class="infolettre-modal__form-wrapper"
        src="https://crecn.symbiotic.coop/iframe.php/civicrm/infolettre-ville-eponge"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'NewsletterModal',
  components: { Icon },
}
</script>
